import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Users, Phone, MessageSquare, BarChart3, Shield, FileText } from "lucide-react";

const quickActions = [
  { label: "Staff Portal", icon: Users, path: "/staff-portal" },
  { label: "Telehealth", icon: Phone, path: "/telehealth" },
  { label: "Call Center", icon: MessageSquare, path: "/admin/triage" },
  { label: "Analytics", icon: BarChart3, path: "/admin/video-analytics" },
  { label: "HIPAA", icon: Shield, path: "/admin/hipaa" },
  { label: "Training", icon: FileText, path: "/academy" },
];

export const QuickActionsCard = ({ customActions }) => {
  const navigate = useNavigate();
  const actions = customActions || quickActions;

  return (
    <Card className="bg-slate-800 border-slate-700" data-testid="quick-actions-card">
      <CardHeader>
        <CardTitle className="text-white">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {actions.map((action, index) => (
            <Button
              key={index}
              variant="outline"
              className="h-20 flex-col border-slate-600 text-slate-300 hover:bg-slate-700 hover:text-white"
              onClick={() => action.onClick ? action.onClick() : navigate(action.path)}
            >
              <action.icon className="w-6 h-6 mb-2" />
              {action.label}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickActionsCard;
